
import React from 'react';

const AuthInfoPanel: React.FC = () => {
  return (
    <div className="hidden md:block md:w-2/5 bg-gradient-to-r from-yellow-500 to-yellow-300 text-darkgray">
      <div className="flex flex-col h-full justify-center p-8 lg:p-10">
        <div className="max-w-md mx-auto">
          <h2 className="text-3xl font-bold mb-4 font-montserrat">
            Effektivisera dina offentliga upphandlingar
          </h2>
          
          <p className="text-lg mb-6 font-opensans">
            Snabbaupphandlingar ger dig insikter för att lyckas med dina anbud.
          </p>
          
          <div className="space-y-4">
            <div className="flex items-start">
              <div className="bg-white/20 p-2 rounded-full mr-3">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <div>
                <h3 className="font-bold mb-1 font-montserrat text-sm">Avancerad analys</h3>
                <p className="font-opensans text-xs">Identifiera mönster och trender som ökar dina vinstchanser.</p>
              </div>
            </div>
            
            <div className="flex items-start">
              <div className="bg-white/20 p-2 rounded-full mr-3">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <div>
                <h3 className="font-bold mb-1 font-montserrat text-sm">Snabb överblick</h3>
                <p className="font-opensans text-xs">Få en strukturerad sammanfattning av alla krav och villkor.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthInfoPanel;
